module.exports = __webpack_public_path__ + "img/filter-switch-desc.8e956663.svg";